const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudyNotesSvgrepoCom(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 26.131308 21.329225 L 28.362994 20.746771 L 23.200043 1.000302 L 3.23832 6.223398 L 0 6.223398 L 0 26.628293 L 2.93443 26.628293 L 3.029396 27.362692 L 8.531057 26.628293 L 23.697029 26.628293 L 23.697029 24.608696 L 26.520666 24.235166 Z M 23.697029 12.801334 L 24.703662 20.370075 L 23.697029 20.632812 Z M 22.278879 2.576727 L 22.690395 4.156318 L 9.534524 5.910012 Z M 22.718885 5.454178 L 22.823347 6.223398 L 16.954486 6.223398 Z M 22.405499 25.33993 L 1.291529 25.33993 L 1.291529 7.511762 L 22.405499 7.511762 Z M 23.697029 23.310836 L 23.697029 21.965493 L 24.874599 21.658438 L 25.067696 23.127236 Z M 25.042371 13.143209 L 26.789734 19.822441 L 25.96037 20.040861 Z M 25.042371 13.143209 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8.518395 10.582309 L 20.123165 10.582309 L 20.123165 11.839018 L 8.518395 11.839018 Z M 8.518395 10.582309 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 8.518395 13.244505 L 20.123165 13.244505 L 20.123165 14.498048 L 8.518395 14.498048 Z M 8.518395 13.244505 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.219629 16.837362 L 20.123165 16.837362 L 20.123165 18.094071 L 4.219629 18.094071 Z M 4.219629 16.837362 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.219629 19.585027 L 20.123165 19.585027 L 20.123165 20.841736 L 4.219629 20.841736 Z M 4.219629 19.585027 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.219629 22.016141 L 20.123165 22.016141 L 20.123165 23.269684 L 4.219629 23.269684 Z M 4.219629 22.016141 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 4.153153 11.832687 C 4.539345 11.870673 4.903379 11.747218 5.18511 11.522466 C 5.026834 11.560453 4.865393 11.579446 4.697621 11.560453 C 3.880919 11.48448 3.279471 10.756412 3.361775 9.93971 C 3.39343 9.610497 3.532712 9.316104 3.741636 9.088187 C 3.269975 9.284449 2.915437 9.72129 2.861624 10.265758 C 2.785651 11.053971 3.361775 11.756714 4.153153 11.832687 Z M 4.153153 11.832687 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "#000000",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 3.668829 10.329068 C 3.823939 11.012819 4.504525 11.440163 5.18511 11.285053 C 5.868861 11.129943 6.232895 10.46202 6.08095 9.778269 C 5.922674 9.097684 5.308565 8.654512 4.624814 8.809622 C 3.941063 8.964732 3.513719 9.645317 3.668829 10.329068 Z M 3.668829 10.329068 ",
    transform: "matrix(1.234002,0,0,1.234002,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyNotesSvgrepoCom);
export default __webpack_public_path__ + "static/media/study-notes-svgrepo-com.32ce3362ffb91970aab7c02288c93d0f.svg";
export { ForwardRef as ReactComponent };